import { Avatar, Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { selectSchool } from "../../../redux/school/schoolSlice";
import { styled } from "@mui/material/styles";
import { stringAvatar, stringToColor } from "../../../features/user/avatarUtils";
import { assertThumbnailUrl } from "../../../redux/common";

const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: 22,
  height: 22,
  border: `2px solid ${theme.palette.background.paper}`,
  fontSize: "0.5rem",
}));

interface SchoolPageAvatarProps {
}

const SchoolPageAvatar = ({}: SchoolPageAvatarProps) => {
  const school = useSelector( selectSchool );

  return school.selected ?
    <Box sx={{ mr: 2 }}>
        <Avatar sx={{ backgroundColor: stringToColor(school.selected.name) }} alt={`${school.selected.name}`} src={`${assertThumbnailUrl(school.selected.url)}`}>
        <Typography variant="h6" component="span">
          {stringAvatar(school.selected.name)}
        </Typography>
      </Avatar>
    </Box>
    : <></>;
};

export default SchoolPageAvatar;